import MuiChip, { ChipProps } from '@mui/material/Chip';
import { styled } from '@mui/material';

const Chip = styled(MuiChip, {
  shouldForwardProp: prop => prop !== 'isDefaultFont'
})<{ isDefaultFont?: boolean }>(({ theme, isDefaultFont }) => ({
  borderRadius: '6px',
  '& .MuiChip-label': {
    ...theme.typography.caption,
    color: theme.palette.common.white,
    ...(isDefaultFont ? { fontSize: '14px', fontWeight: 400 } : { fontWeight: 700 })
  }
}));

export default Chip;
export type { ChipProps };
